import { render, staticRenderFns } from "./PublicNftMint.vue?vue&type=template&id=4f6304d8&scoped=true&"
import script from "./PublicNftMint.vue?vue&type=script&lang=js&"
export * from "./PublicNftMint.vue?vue&type=script&lang=js&"
import style0 from "./PublicNftMint.vue?vue&type=style&index=0&id=4f6304d8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f6304d8",
  null
  
)

export default component.exports